import { Instant } from "@js-joda/core"

export type DeviceType = "blood-glucose-monitor" | "blood-pressure-monitor"

export type DeviceVendor = "smartmeter" | "impilo"

export type Device = {
  id: string
  serialNumber: string
  imei?: string
  patientId?: string
  organizationId: string
  vendor: DeviceVendor
  type: DeviceType
  numberOfReadings: number
  numberOfSessions: number
  suspendedAt?: Instant
  suspendReason?: string
}

export const deviceTypes: { title: string; value: DeviceType }[] = [
  {
    value: "blood-glucose-monitor",
    title: "Blood glucose monitor",
  },
  {
    value: "blood-pressure-monitor",
    title: "Blood pressure monitor",
  },
]

export const deviceVendors: { title: string; value: DeviceVendor }[] = [
  {
    value: "smartmeter",
    title: "SmartMeter",
  },
  {
    value: "impilo",
    title: "Impilo",
  },
]

export const deviceTypeNameFor = (type: DeviceType): string => {
  return deviceTypes.find(({ value }) => value === type)!.title
}

export const deviceVendorNameFor = (vendor: DeviceVendor): string => {
  return deviceVendors.find(({ value }) => value === vendor)!.title
}
